module.exports = __webpack_public_path__ + "img/wllx.95257f7e.png";